import { Component, inject, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { BuildingSectionItemDto } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-reassign-section-dialog',
  templateUrl: './reassign-section-dialog.component.html',
})
export class ReassignSectionDialogComponent {

  private readonly dialogRef = inject(NbDialogRef);

  @Input()
  sections: BuildingSectionItemDto[] = [];
  @Input()
  count = 0;

  selectedSectionId: string = '';

  onSubmit = (): string | null => {
    return this.selectedSectionId === '' ? null : this.selectedSectionId;
  };

  onCancel(): void {
    this.dialogRef.close(undefined);
  }
}
